import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseSaveResiliation: ReponseEnveloppe<boolean> = {
    reponse: true
}
